export enum AssistantModality {
  VOICE = "VOICE",
  TEXT = "TEXT",
}
